import React from "react";
import { Button } from "reactstrap";
import HoverImage from "react-hover-image/build";
import SaveIcon from "assets/icon/save-icon.svg";
import SaveHoverIcon from "assets/icon/save-icon-hover.svg";
import CancleIcon from "assets/icon/cancel-icon.svg";
import CancleHoverIcon from "assets/icon/cancel-Hover-icon.svg";
import EditIcon from "assets/icon/Edit-icon.svg";
import EditHoverIcon from "assets/icon/Edit-Hover-icon.svg";


const CellOptions = (props) => {
  const { row, onEdit, onSave, editTitle, saveTitle, saveDisabled } = props;
  if (row.isEdit) {
    return (
      <div className="d-flex align-items-center">
        <Button
           className="icon text-primary p-0 text-decoration-none"
          color="link"
          disabled={saveDisabled}
          onClick={onSave}
          title={saveTitle}
        >
          <HoverImage
            key="SaveIcon"
            src={SaveIcon}
            hoverSrc={SaveHoverIcon}
            alt=""
          />
        </Button>
        <Button
         className="edit icon text-primary p-0 text-decoration-none"
         style={{marginLeft: '0px'}}
         color="link"
         title="Cancel"
          onClick={() => onEdit(row, false)}
        >
          <HoverImage src={CancleIcon} hoverSrc={CancleHoverIcon} alt="" />
        </Button>
      </div>
    );
  } else {
    return (
      <div className="d-flex align-items-center">
        <Button
         className="icon text-primary p-0 text-decoration-none"
         color="link"
         title={editTitle}
          onClick={() => onEdit(row)}
        >
          <HoverImage src={EditIcon} hoverSrc={EditHoverIcon} alt="" />
        </Button>
      </div>
    );
  }
};

export default CellOptions;
